// extracted by mini-css-extract-plugin
export default {"contenedor":"boxFlotante_contenedor__8BMV3","container":"boxFlotante_container__rfg1c","containerNone":"boxFlotante_containerNone__V+VQE"};